import React from 'react';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';

export const chatSender = {
    user: 'user',
    ai: 'ai',
};

export const INITIAL_CHAT_STATE = [
    {
        sender: chatSender.ai,
        messageId: 'landing.pages.form.chat.history.message.1',
        defaultText: 'Welcome to the Landing Page Editor! 👋',
    },
    {
        sender: chatSender.ai,
        messageId: 'landing.pages.form.chat.history.message.2',
        defaultText:
            "You can preview your landing page on the right and use this chat to make changes. Just tell me what you'd like to modify, and I'll help you update the content.",
    },
];

export const DISABLED_CHAT_STATE = [
    {
        sender: chatSender.ai,
        message: (
            <FormattedMessage
                id="landing.pages.form.chat.history.message.1"
                defaultMessage="Welcome to the Landing Page Editor! 👋"
            />
        ),
    },
    {
        sender: chatSender.ai,
        message: (
            <FormattedMessage
                id="landing.pages.form.chat.history.message.disabled"
                defaultMessage="Please fill out and submit the form in the previous step to continue."
            />
        ),
    },
];
